let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("bPgcq")).then(() => parcelRequire('4zXPl'));